(function productRecommendationsControllerFactory(root) {
  function normalizeLimit(value) {
    const parsedValue = Number.parseInt(value, 10);

    if (!Number.isFinite(parsedValue)) {
      return 8;
    }

    return Math.min(10, Math.max(1, parsedValue));
  }

  function buildRecommendationsUrl(baseUrl, config = {}) {
    const params = new URLSearchParams({
      section_id: String(config.sectionId || ''),
      product_id: String(config.productId || ''),
      limit: String(normalizeLimit(config.limit)),
      intent: String(config.intent || 'related'),
    });

    return `${baseUrl}?${params.toString()}`;
  }

  function createProductRecommendations(config = {}) {
    return {
      loaded: Boolean(config.performed),
      loading: false,
      requestController: null,

      destroy() {
        this.requestController?.abort();
        this.requestController = null;
      },

      async load() {
        if (this.loaded || this.loading || !root.fetch || !config.baseUrl || !config.productId) {
          return;
        }

        this.loading = true;
        this.requestController = root.AbortController ? new root.AbortController() : null;

        try {
          const response = await root.fetch(buildRecommendationsUrl(config.baseUrl, config), {
            headers: {
              Accept: 'text/html',
            },
            signal: this.requestController?.signal,
          });

          if (!response.ok) {
            return;
          }

          const html = await response.text();
          const parser = new root.DOMParser();
          const document = parser.parseFromString(html, 'text/html');
          const content = document.querySelector(`[data-recommendations-content="${config.sectionId}"]`);

          if (content && this.$refs.content) {
            this.$refs.content.innerHTML = content.innerHTML;
            root.Alpine.initTree(this.$refs.content);
            this.loaded = true;
          }
        } catch (error) {
          if (error.name !== 'AbortError') {
            this.loaded = false;
          }
        } finally {
          this.loading = false;
          this.requestController = null;
        }
      },
    };
  }

  function registerAlpine() {
    if (!root.document || !root.Alpine) {
      return;
    }

    root.Alpine.data('productRecommendations', createProductRecommendations);
  }

  if (root.document) {
    root.document.addEventListener('alpine:init', registerAlpine);
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      buildRecommendationsUrl,
      createProductRecommendations,
      normalizeLimit,
    };
  }
})(typeof window !== 'undefined' ? window : globalThis);
